import MicroModal from 'micromodal';
import { Component } from '../../../libs/gin-tonic/helpers/compiler';

@Component({ className: 'js-lets-talk' })
export class LetsTalkComponent {
	constructor(private element: HTMLElement) {
		this.element.addEventListener('click', () => MicroModal.show('modal-lets-talk', {
			disableFocus: false,
			awaitOpenAnimation: true,
			awaitCloseAnimation: true,
		}));
	}
}
